module.exports = __webpack_public_path__ + "static/media/mahjong-3d.852899d3.png";